
<div class="sticky top-0 z-50 header-box-shadow">
  <div class="header-main-container flex flex-col lg:flex-row justify-center items-center font-rubik">
    <div class="header-content-wrapper w-full h-full flex flex-row justify-center items-center">
      <!-- Desktop -->
      <div class="max-w-1440 w-full h-full hidden px-6 lg:flex flex-col gap-2">
        <div class="w-full h-full hidden lg:flex flex-row justify-between items-center" style="min-height: 60px;">
          <Logo />
          <DropdownButtons
            ref="dropdownButtons"
            @update:activeButton="handleActiveButtonChange"
          />
          <FindInventory class="find-inventory" />
  
          <!-- Phone and quote button (Desktop) -->
          <div class="flex flex-row justify-between items-center gap-4">
            <a :href="`tel:${organizationPhone || phoneNumber}`" class="header-phone hidden lg:inline">
              {{ formatPhoneNumber(organizationPhone || phoneNumber) }}
            </a>
            <quote-summary-dropdown v-if="quote && !isMobile" key="desktop-quote" />
            <button v-else class="get-quote-button flex items-center justify-center" 
              data-vue-init="lead-flow" data-props='{ "gtag": "get_quote"}'
            >
              <p>Get Quote</p>
            </button>
          </div>
        </div>

        <!-- Service Area and Partners links row -->
        <transition name="fade-slide">
          <div v-if="showFullHeader && showLastRowNavLinks" class="full-header-container w-full hidden lg:flex flex-col justify-center">
            <NavigationRow
              :organization="organization"
              :solutions="solutions"
              :organizationPhone="organizationPhone"
              :phoneNumber="phoneNumber"
              :formatPhoneNumber="formatPhoneNumber"
              :city="city"
              :state="state"
              :solutionsPath="solutionsPath"
            />
          </div>
        </transition>

        <!-- Dropdown Container -->
        <div 
          v-if="activeDropdown"
          ref="desktopDropdown"
          :class="['header-dropdown-container header-box-shadow w-full hidden lg:flex flex-col justify-center items-center', showFullHeader && showLastRowNavLinks ? 'header-dropdown-container-full-header-top' : 'header-dropdown-container-default-top']"
        > 
          <DesktopDropdown :activeDropdown="activeDropdown" :dropdownLinks="dropdownLinks" />
        </div>
      </div>
  
      <!-- Mobile -->
      <div class="lg:hidden w-full h-full px-4 flex flex-col">
        <div :class="['w-full h-full flex flex-row justify-between items-center', showMobileBottomNav ? 'mobile-header-min-h' : '']">
          <Logo />
          <div v-if="!isActiveMobileMenu" class="flex flex-row justify-between items-center gap-2">
            <quote-summary-dropdown v-if="quote && isMobile" key="mobile-quote" />
            <MobileGetQuoteButton v-else /> 
            <MobilePhoneButton :organizationPhone="organizationPhone" :phoneNumber="phoneNumber" />
            <MobileHamburgerButton @update:activeMobileMenu="handleActiveMobileMenuChange" />
          </div>
          <MobileCloseButton v-if="isActiveMobileMenu" @update:activeMobileMenu="handleActiveMobileMenuChange" />
        </div>
        <MobilePartnerLocationRow v-if="showMobileBottomNav && showFullHeader && !isActiveMobileMenu" :organization="organization" :city="city" :state="state" />
      </div>
    </div>
  </div>
  <MobileSideMenu
    class="lg:hidden"
    v-if="isActiveMobileMenu"
    :dropdownLinks="dropdownLinks" 
    @close="handleActiveMobileMenuChange(false)" 
  />
  <div
    class="lg:hidden bottom-nav"
    v-if="!isActiveMobileMenu && showFullHeader && showMobileBottomNav"
  >
    <MobileBottomNav
      :organization="organization"
      :solutionsPath="solutionsPath"
      :solutions="solutions"
    />
  </div>
</div>
